<mat-card>
    <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
      <h3 class="page-header">Filter Groups</h3>
      <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="end center">
        <button mat-icon-button (click)="loadFilterGroups()" type="button" matTooltip="Refresh" [disabled]="isLoading">
          <mat-icon>refresh</mat-icon>
        </button>
        <button mat-raised-button color="primary" (click)="addFilterGroup()" type="button">Add Filter Group</button>
      </div>
    </mat-card-title>
    <mat-card-content style="min-height: 500px;">
      <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center" style="padding: 40px;">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="!isLoading">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="derivedFieldName">
          <th mat-header-cell *matHeaderCellDef>Derived Field Name</th>
          <td mat-cell *matCellDef="let row">{{ row.derivedFieldName }}</td>
        </ng-container>

        <ng-container matColumnDef="derivedFieldValue">
          <th mat-header-cell *matHeaderCellDef>Derived Value</th>
          <td mat-cell *matCellDef="let row">{{ row.derivedFieldValue }}</td>
        </ng-container>

        <ng-container matColumnDef="retroactiveFromDate">
          <th mat-header-cell *matHeaderCellDef>Retroactive From</th>
          <td mat-cell *matCellDef="let row">{{ row.retroactiveFromDate ? (row.retroactiveFromDate | date:'mediumDate') : '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef>Active</th>
          <td mat-cell *matCellDef="let row">
            <mat-icon [style.color]="row.isActive ? 'green' : '#ccc'">
              {{ row.isActive ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="conditionOperator">
          <th mat-header-cell *matHeaderCellDef>Operator</th>
          <td mat-cell *matCellDef="let row">{{ row.conditionOperator }}</td>
        </ng-container>

        <ng-container matColumnDef="conditions">
          <th mat-header-cell *matHeaderCellDef>Conditions</th>
          <td mat-cell *matCellDef="let row">{{ getConditionsSummary(row) }}</td>
        </ng-container>

        <ng-container matColumnDef="jobStatus">
          <th mat-header-cell *matHeaderCellDef>Job Status</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.jobStatus" [ngClass]="{
              'status-pending':   row.jobStatus === 'pending',
              'status-running':   row.jobStatus === 'running',
              'status-completed': row.jobStatus === 'completed',
              'status-failed':    row.jobStatus === 'failed'
            }">{{ row.jobStatus | titlecase }}</span>
            <span *ngIf="!row.jobStatus" style="color:#ccc;">—</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="jobProgress">
          <th mat-header-cell *matHeaderCellDef>Progress</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.jobProgress != null">{{ row.jobProgress }}%</span>
            <span *ngIf="row.jobProgress == null" style="color:#ccc;">—</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="jobEtaHours">
          <th mat-header-cell *matHeaderCellDef>ETA (hrs)</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.jobEtaHours != null">{{ row.jobEtaHours }}</span>
            <span *ngIf="row.jobEtaHours == null" style="color:#ccc;">—</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button color="primary" (click)="editFilterGroup(row)" title="Edit" type="button">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="viewLogs(row)" title="View Logs" type="button"
              *ngIf="row.jobStatus" matTooltip="View Logs">
              <mat-icon>article</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [colSpan]="displayedColumns.length" style="text-align: center; padding: 24px;">
            <div class="no-data">No filter groups found. Click "Add Filter Group" to create one.</div>
          </td>
        </tr>
      </table>
    </mat-card-content>
</mat-card>
